import { render, staticRenderFns } from "./SuitesHeader.vue?vue&type=template&id=ae92fd48"
import script from "./SuitesHeader.vue?vue&type=script&lang=ts"
export * from "./SuitesHeader.vue?vue&type=script&lang=ts"
import style0 from "./SuitesHeader.vue?vue&type=style&index=0&id=ae92fd48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports